import { render, staticRenderFns } from "./DepartmentTreeNode.vue?vue&type=template&id=37804bbc"
import script from "./DepartmentTreeNode.vue?vue&type=script&lang=js"
export * from "./DepartmentTreeNode.vue?vue&type=script&lang=js"
import style0 from "./DepartmentTreeNode.vue?vue&type=style&index=0&id=37804bbc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports